import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponet";
import { Trails } from "./Trails";

export class TrailsComponent extends AbstractDisplayComponent {
    public container: Trails;

    public override init() {
        let containerConfig = {
            labelName: "trails_container",
            anchorX: 0.5,
            anchorY: 0.5,
            landscape: {
                posX: 0,
                posY: 133,
                scale: 1,
            },
            portrait: {
                posX: 0,
                posY: 133,
                scale: 1,
            }
        };
        super.init();
        this.container = new Trails(containerConfig);
    }

    public getInstance(): Trails {
        return this.container;
    }

    // public triggerTrail(symbol: any, meter: any, id: number, callback: () => void) {
    //     (this.container as Trails).triggerTrail(symbol, meter, id, callback);
    // }

    public override destroy(): void {
        this.container.destroy({ children: true });
    }

}
